<template>
	<div class="col-12 pl-0 pr-0">
		<div class="col-12 pl-0 pr-0" v-if="step == 1">
			<div class="col-12 pl-md-4 pr-md-4 pt-2 pb-2 bg-light-blue mt-3 color-white cus-box-shadow rounded-cus font-size-10 d-flex">
				<i class="fas fa-box-open mt-auto mb-auto"></i>
				<div class="pl-2">Silahkan pilih metode pembayaran Anda agar pembayaran anda dapat diproses</div>
			</div>
			<div class="col-12 pl-md-4 pr-md-4 pt-3 pt-md-4 pb-3 mt-3 bg-white cus-box-shadow rounded-cus d-flex flex-wrap">
				<div class="col-lg-12 pl-0 pr-0">
					<div class="col-12 pl-0 pr-0 d-flex font-size-10">
						<div class="col-6 pl-0 pr-0 pl-md-0 mt-auto mb-auto font-size-sm-9">Pilih Metode Pembayaran</div>
						<div class="col-6 pl-2 pr-0">
							<v-select label="text" class="font-size-10 font-size-sm-9 pt-1 pb-1" :options="payment" v-model="paymentMethod"
								return-object @input="resetPaymentValue">
							</v-select>

							<!-- {{ paymentMethod }} -->
						</div>
					</div>
					<div class="col-12 pl-0 pr-0 font-size-10 mt-3 border-top" v-if="paymentMethod.value == 1">
						<div
							class="col-12 pl-md-4 pr-md-4 pt-2 pb-2 bg-blue mt-3 mb-3 color-white cus-box-shadow rounded-cus font-size-10 d-flex">
							<div class="pl-2">Order akan diproses pada jam operasional.</div>
						</div>
						<div class="col-12 d-md-flex pl-0 pr-0">
							<div class="col-12 col-md-12 pl-0 mb-3">
								<!-- <div class="col-12" v-for="(bank, index) in dataBankAccount" :key="index" v-bind:class="{'mt-3': index == 0}">
									<label class="product-name transfer color-black mb-0 pl-0">
										<div class="background-white z-index-1 pb-2 pb-md-0 pt-1">
											<h2 class="mb-0 d-flex">
												<input type="radio" name="radio" v-model="paymentValue" v-bind:value="bank.bank_account_bank" @change="setPaymentMethodValue(bank)">
												<div class="col-3 offset-1"><img class="width-90 img-fluid pt-3 pt-md-0" :src="'assets/bank/'+bank.bank_account_bank.toLowerCase()+'.svg'" alt=""></div>
												<div class="col-9 font-size-10 color-black font-size-sm-10 m-auto">
													<div><span class="f-lato">{{ bank.bank_account_no }}</span> a/n {{bank.bank_account_name}}</div>
												</div>
											</h2>
										</div>
									</label>
								</div> -->
								<div class="font-size-9 pb-1">Nama Bank Tujuan <span class="color-red">*</span></div>
								<v-select v-model="paymentValueObj" :options="dataBankAccount" appendToBody
									class="font-size-10 rounded-cus focus-me" label="bank_account_bank" :reduce="el => el"
									placeholder="Nama Bank Tujuan" @input="setPaymentObj()" return-object>
									<template v-slot:no-options>
										Tidak ada data bank
									</template>
								</v-select>
							</div>
						</div>
						<div class="col-12 d-md-flex pl-0 pr-0 border-bottom mb-3">
							<div class="col-12 col-md-12 pl-0 mb-3">
								<div class="font-size-9 pb-1">Nama Bank Tujuan</div>
								<input class="form-control box-blue rounded-cus font-size-9" type="text" placeholder=""
									v-model="paymentValueName" readonly="">
							</div>
						</div>
						<div class="col-12 d-md-flex pl-0 pr-0">
							<div class="col-12 col-md-6 pl-0 mb-3">
								<div class="font-size-9 pb-1">Nama Bank Pengirim <span class="color-red">*</span></div>
								<!-- <input class="form-control box-blue rounded-cus font-size-9" type="text" placeholder="e.g Bank XXX" v-model="customer_bank_name" @change="validatePaymentBank()"> -->
								<v-select v-model="customer_bank_name" :options="dataBank" appendToBody class="font-size-10 rounded-cus focus-me"
									label="bank_name" :reduce="el => el.bank_name" placeholder="Nama Bank Pengirim" return-object
									@input="validatePaymentBank()">
									<template v-slot:no-options>
										Tidak ada data bank
									</template>
								</v-select>
							</div>
							<div class="col-12 col-md-6 pl-0 mb-3">
								<div class="font-size-9 pb-1">Nama Rekening Pengirim <span class="color-red">*</span></div>
								<input class="form-control box-blue rounded-cus font-size-9" type="text" placeholder="e.g John Doe"
									v-model="customer_bank_customer_name" @change="validatePaymentBank()">
							</div>
						</div>
						<div class="col-12 d-md-flex pl-0 pr-0">
							<div class="col-12 col-md-6 pl-0 mb-3">
								<div class="font-size-9 pb-1">Nomor Rekening Pengirim <span class="color-red">*</span></div>
								<input class="form-control box-blue rounded-cus font-size-9" type="text" placeholder="e.g 115475"
									v-model="customer_bank_customer_number" @change="validatePaymentBank()" @keypress="onlyNumber"
									@paste.prevent>
							</div>
						</div>
					</div>
					<div class="col-12 pl-0 pr-0 font-size-10 mt-3 border-top" v-if="paymentMethod.value == 2">
						<div class="col-12" v-for="(va, index) in Virtual_Account" :key="index" v-bind:class="{ 'mt-3': index == 0 }">
							<label class="product-name transfer color-black mb-0 pl-0">
								<div class="background-white z-index-1 pb-2 pb-md-0 pt-1">
									<h2 class="mb-0 d-flex">
										<input type="radio" name="radio" v-model="paymentValue" v-bind:value="va.payment_value"
											@change="setPaymentMethodValue(va)">
										<div class="col-3 offset-1"><img class="width-90 img-fluid pt-3 pt-md-0"
												:src="'assets/bank/' + va.payment_value.toLowerCase() + '.svg'" alt=""></div>
										<div class="col-9 font-size-10 color-black font-size-sm-10 m-auto">
											<div>{{ va.name }}</div>
										</div>
									</h2>
								</div>
							</label>
						</div>
					</div>
					<div class="col-12 pl-0 pr-0 font-size-10 mt-3 border-top" v-if="paymentMethod.value == 3">
						<div
							class="col-12 pl-md-4 pr-md-4 pt-2 pb-2 bg-blue mt-3 mb-3 color-white cus-box-shadow rounded-cus font-size-10 d-flex">
							<div class="pl-2">Order akan diproses pada jam operasional.</div>
						</div>
						<div class="col-12 pl-0 pb-2 d-flex align-items-center justify-content-between">
							<div class="d-flex align-items-center">
								<div class="font-size-10 pr-2">Split Payment {{ split_payment }}/3</div>
								<button class="btn btn-sm btn-blue rounded-circle font-size-9" @click="addSplitPayment()"
									:disabled="split_payment == 3 || remaining_amount == 0"><i class="fas fa-plus"></i></button>
							</div>
							<div>
								<div class="font-size-10 font-weight-bold">Sisa Pembayaran: {{ remaining_amount | toRupiah }}</div>
							</div>
						</div>
						<div class="col-12 px-4 py-2 bg-white rounded-cus mb-3 cus-box-shadow">
							<div class="col-12 d-md-flex pl-0 pr-0">
								<div class="col-12 col-md-12 pl-0 mb-3">
									<div class="font-size-9 pb-1">Nama Bank Tujuan <span class="color-red">*</span></div>
									<v-select v-model="splitPayment[0].paymentValueObj" :options="dataBankAccount" appendToBody
										class="font-size-10 rounded-cus focus-me" label="bank_account_bank" :reduce="el => el"
										placeholder="Nama Bank Tujuan" @input="setSplitPaymentObj(0)" return-object>
										<template v-slot:no-options>
											Tidak ada data bank
										</template>
									</v-select>
								</div>
							</div>
							<div class="col-12 d-md-flex pl-0 pr-0 border-bottom mb-3">
								<div class="col-12 col-md-12 pl-0 mb-3">
									<div class="font-size-9 pb-1">Nama Bank Tujuan</div>
									<input class="form-control box-blue rounded-cus font-size-9" type="text" placeholder=""
										v-model="splitPayment[0].paymentValueName" readonly="">
								</div>
							</div>
							<div class="col-12 d-md-flex pl-0 pr-0">
								<div class="col-12 col-md-6 pl-0 mb-3">
									<div class="font-size-9 pb-1">Nama Bank Pengirim <span class="color-red">*</span></div>
									<!-- <input class="form-control box-blue rounded-cus font-size-9" type="text" placeholder="e.g Bank XXX" v-model="customer_bank_name" @change="validatePaymentBank()"> -->
									<v-select v-model="customerBankSplitPayment[0].customer_bank_name" :options="dataBank" appendToBody
										class="font-size-10 rounded-cus focus-me" label="bank_name" :reduce="el => el.bank_name"
										placeholder="Nama Bank Pengirim" return-object @input="validateSplitPaymentBank(0)">
										<template v-slot:no-options>
											Tidak ada data bank
										</template>
									</v-select>
								</div>
								<div class="col-12 col-md-6 pl-0 mb-3">
									<div class="font-size-9 pb-1">Nama Rekening Pengirim <span class="color-red">*</span></div>
									<input class="form-control box-blue rounded-cus font-size-9" type="text" placeholder="e.g John Doe"
										v-model="customerBankSplitPayment[0].customer_bank_customer_name" @change="validateSplitPaymentBank(0)">
								</div>
							</div>
							<div class="col-12 d-md-flex pl-0 pr-0">
								<div class="col-12 col-md-6 pl-0 mb-3">
									<div class="font-size-9 pb-1">Nomor Rekening Pengirim <span class="color-red">*</span></div>
									<input class="form-control box-blue rounded-cus font-size-9" type="text" placeholder="e.g 115475"
										v-model="customerBankSplitPayment[0].customer_bank_customer_number" @change="validateSplitPaymentBank(0)"
										@keypress="onlyNumber" @paste.prevent>
								</div>
								<div class="col-12 col-md-6 pl-0 mb-3">
									<div class="font-size-9 pb-1">Nominal (Rp.) <span class="color-red">*</span></div>
									<input class="form-control box-blue rounded-cus font-size-9" type="text" placeholder="e.g 100000"
										v-model="customerBankSplitPayment[0].customer_bank_transfer_amount" @change="validateSplitPaymentBank(0)"
										@input="($event) => { onlyNumber($event); remainCheck($event, 0); }" @paste.prevent>
								</div>
							</div>
						</div>
						<div class="col-12 px-4 py-2 bg-white rounded-cus mb-3 cus-box-shadow">
							<div class="col-12 d-md-flex pl-0 pr-0">
								<div class="col-12 col-md-12 pl-0 mb-3">
									<div class="font-size-9 pb-1">Nama Bank Tujuan <span class="color-red">*</span></div>
									<v-select v-model="splitPayment[1].paymentValueObj" :options="dataBankAccount" appendToBody
										class="font-size-10 rounded-cus focus-me" label="bank_account_bank" :reduce="el => el"
										placeholder="Nama Bank Tujuan" @input="setSplitPaymentObj(1)" return-object>
										<template v-slot:no-options>
											Tidak ada data bank
										</template>
									</v-select>
								</div>
							</div>
							<div class="col-12 d-md-flex pl-0 pr-0 border-bottom mb-3">
								<div class="col-12 col-md-12 pl-0 mb-3">
									<div class="font-size-9 pb-1">Nama Bank Tujuan</div>
									<input class="form-control box-blue rounded-cus font-size-9" type="text" placeholder=""
										v-model="splitPayment[1].paymentValueName" readonly="">
								</div>
							</div>
							<div class="col-12 d-md-flex pl-0 pr-0">
								<div class="col-12 col-md-6 pl-0 mb-3">
									<div class="font-size-9 pb-1">Nama Bank Pengirim <span class="color-red">*</span></div>
									<!-- <input class="form-control box-blue rounded-cus font-size-9" type="text" placeholder="e.g Bank XXX" v-model="customer_bank_name" @change="validatePaymentBank()"> -->
									<v-select v-model="customerBankSplitPayment[1].customer_bank_name" :options="dataBank" appendToBody
										class="font-size-10 rounded-cus focus-me" label="bank_name" :reduce="el => el.bank_name"
										placeholder="Nama Bank Pengirim" return-object @input="validateSplitPaymentBank(1)">
										<template v-slot:no-options>
											Tidak ada data bank
										</template>
									</v-select>
								</div>
								<div class="col-12 col-md-6 pl-0 mb-3">
									<div class="font-size-9 pb-1">Nama Rekening Pengirim <span class="color-red">*</span></div>
									<input class="form-control box-blue rounded-cus font-size-9" type="text" placeholder="e.g John Doe"
										v-model="customerBankSplitPayment[1].customer_bank_customer_name" @change="validateSplitPaymentBank(1)">
								</div>
							</div>
							<div class="col-12 d-md-flex pl-0 pr-0">
								<div class="col-12 col-md-6 pl-0 mb-3">
									<div class="font-size-9 pb-1">Nomor Rekening Pengirim <span class="color-red">*</span></div>
									<input class="form-control box-blue rounded-cus font-size-9" type="text" placeholder="e.g 115475"
										v-model="customerBankSplitPayment[1].customer_bank_customer_number" @change="validateSplitPaymentBank(1)"
										@keypress="onlyNumber" @paste.prevent>
								</div>
								<div class="col-12 col-md-6 pl-0 mb-3">
									<div class="font-size-9 pb-1">Nominal (Rp.) <span class="color-red">*</span></div>
									<input class="form-control box-blue rounded-cus font-size-9" type="text" placeholder="e.g 100000"
										v-model="customerBankSplitPayment[1].customer_bank_transfer_amount" @change="validateSplitPaymentBank(1)"
										@input="($event) => { onlyNumber($event); remainCheck($event, 1); }" @paste.prevent>
								</div>
							</div>
						</div>
						<div class="col-12 px-4 py-2 bg-white rounded-cus mb-3 cus-box-shadow" v-if="split_payment >= 3">
							<div class="col-12 d-md-flex pl-0 pr-0">
								<div class="col-12 col-md-12 pl-0 mb-3">
									<div class="font-size-9 pb-1 d-flex justify-content-between">
										<div>
											Nama Bank Tujuan <span class="color-red">*</span>
										</div>
										<button class="btn btn-sm btn-danger rounded-circle font-size-10" @click="removeSplitPayment(2)"
											:disabled="split_payment != 3"><i class="fas fa-trash"></i></button>
									</div>
									<v-select v-model="splitPayment[2].paymentValueObj" :options="dataBankAccount" appendToBody
										class="font-size-10 rounded-cus focus-me" label="bank_account_bank" :reduce="el => el"
										placeholder="Nama Bank Tujuan" @input="setSplitPaymentObj(2)" return-object>
										<template v-slot:no-options>
											Tidak ada data bank
										</template>
									</v-select>
								</div>
							</div>
							<div class="col-12 d-md-flex pl-0 pr-0 border-bottom mb-3">
								<div class="col-12 col-md-12 pl-0 mb-3">
									<div class="font-size-9 pb-1">Nama Bank Tujuan</div>
									<input class="form-control box-blue rounded-cus font-size-9" type="text" placeholder=""
										v-model="splitPayment[2].paymentValueName" readonly="">
								</div>
							</div>
							<div class="col-12 d-md-flex pl-0 pr-0">
								<div class="col-12 col-md-6 pl-0 mb-3">
									<div class="font-size-9 pb-1">Nama Bank Pengirim <span class="color-red">*</span></div>
									<!-- <input class="form-control box-blue rounded-cus font-size-9" type="text" placeholder="e.g Bank XXX" v-model="customer_bank_name" @change="validatePaymentBank()"> -->
									<v-select v-model="customerBankSplitPayment[2].customer_bank_name" :options="dataBank" appendToBody
										class="font-size-10 rounded-cus focus-me" label="bank_name" :reduce="el => el.bank_name"
										placeholder="Nama Bank Pengirim" return-object @input="validateSplitPaymentBank(2)">
										<template v-slot:no-options>
											Tidak ada data bank
										</template>
									</v-select>
								</div>
								<div class="col-12 col-md-6 pl-0 mb-3">
									<div class="font-size-9 pb-1">Nama Rekening Pengirim <span class="color-red">*</span></div>
									<input class="form-control box-blue rounded-cus font-size-9" type="text" placeholder="e.g John Doe"
										v-model="customerBankSplitPayment[2].customer_bank_customer_name" @change="validateSplitPaymentBank(2)">
								</div>
							</div>
							<div class="col-12 d-md-flex pl-0 pr-0">
								<div class="col-12 col-md-6 pl-0 mb-3">
									<div class="font-size-9 pb-1">Nomor Rekening Pengirim <span class="color-red">*</span></div>
									<input class="form-control box-blue rounded-cus font-size-9" type="text" placeholder="e.g 115475"
										v-model="customerBankSplitPayment[2].customer_bank_customer_number" @change="validateSplitPaymentBank(2)"
										@keypress="onlyNumber" @paste.prevent>
								</div>
								<div class="col-12 col-md-6 pl-0 mb-3">
									<div class="font-size-9 pb-1">Nominal (Rp.) <span class="color-red">*</span></div>
									<input class="form-control box-blue rounded-cus font-size-9" type="text" placeholder="e.g 100000"
										v-model="customerBankSplitPayment[2].customer_bank_transfer_amount" @change="validateSplitPaymentBank(2)"
										@input="($event) => { onlyNumber($event); remainCheck($event, 2); }" @paste.prevent>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import vSelect from "vue-select";
import { mapState, mapActions, mapMutations } from 'vuex';

export default {
	components: {
		vSelect
	},
	data() {
		return {
			success: true,
			bank: [],
			split_payment: 2,
			payment: [
				{
					text: "Bank",
					value: 1
				},
				{
					text: "Virtual Account",
					value: 2
				},
				{
					text: "Split Payment",
					value: 3
				},
				// {
				// 	text: "Tunai",
				// 	value: 3
				// }
				// }, {
				// 	text: "Kartu Kredit",
				// 	value: 4
			],
			Virtual_Account: [
				{
					name: "Virtual Account BCA",
					img: "assets/bank/bca.svg",
					payment_value: 'bca',
					tutorial: [
						{
							"via": "ATM BCA",
							"tutorial": [
								"Kunjungi ATM Terdekat dan masukkan PIN Anda", "Pada menu utama, pilih menu <b> Transaksi Lainnya </b>", "Pilih menu <b>Transfer</b> dan kemudian pilih <b>BCA Virtual Account</b>", "Masukkan no. BCA Virtual Account Anda  & klik <b>Lanjutkan</b>", "Periksa kembali rincian pembayaran Anda, lalu pilih Ya", "Transaksi Anda berhasil"
							]
						},
						{
							"via": "Klik BCA",
							"tutorial": [
								"Login pada aplikasi KlikBCA, masukkan user ID & PIN.", "Pilih <b>Transfer Dana</b>, kemudian pilih <b>Transfer ke BCA Virtual Account</b>.", "Masukkan no. BCA Virtual Account Anda  & klik <b>Lanjutkan</b>.", "Periksa rincian pembayaran Anda & klik <b>Lanjut</b>", "Pastikan data yang dimasukkan sudah benar, dan Input <b>Respon KeyBCA</b>, lalu klik <b>Kirim</b>", "Transaksi Berhasil."
							]
						},
						{
							"via": "Mobile BCA",
							"tutorial": [
								"Login pada aplikasi M-BCA, masukkan PIN M-BCA.", "Pilih <b>m-Transfer</b>, pilih <b>BCA Virtual Account</b>.", "Klik <b>Input no. Virtual Account</b>, lalu masukkan no BCA Virtual Account Anda", "Klik <b>OK</b> & <b>Send</b>.", "Periksa rincian pembayaran Anda kemudian pilih <b>OK<b> kemudian masukkan PIN M-BCA Anda.", "Periksa kembali data transaksi Anda, kemudian klik <b>OK</b>", "Transaksi Anda berhasil"
							]
						}
					]
				},
			],
			month: [{
				text: "01",
				value: 1
			}, {
				text: "02",
				value: 2
			}],
			year: [{
				text: "2020",
				value: 0
			}, {
				text: "2021",
				value: 1
			}],
			selected: '',
			paymentMethod: '',
			paymentValue: '',
			bankSelected: {},
			customer_bank_name: '',
			customer_bank_customer_name: '',
			customer_bank_customer_number: '',
			paymentValueObj: {},
			paymentValueName: '',

			splitPaymentValue: [],
			splitPayment: [
				{
					paymentValueObj: null,
					paymentValueName: '',
				},
				{
					paymentValueObj: null,
					paymentValueName: '',
				}
			],
			customerBankSplitPayment: [
				{
					customer_bank_name: '',
					customer_bank_customer_name: '',
					customer_bank_customer_number: '',
					customer_bank_transfer_amount: ''
				},
				{
					customer_bank_name: '',
					customer_bank_customer_name: '',
					customer_bank_customer_number: '',
					customer_bank_transfer_amount: ''
				}
			],
			customerBankSplitSaved: [],
			lastValidAmount: [0, 0, 0], // Array untuk menyimpan nilai terakhir yang valid,
			minimumPaymentMaterai: 5000000
		}
	},
	props: {
		registrationData: {
			type: Object
		},
	},
	computed: {
		...mapState('po_cart', ['cart', 'dataSerial', 'selectedPayment', 'step', 'paymentProgress', 'responsePayment','progressive_price_data','shipping_cost']),
		...mapState('po', ['dataBankAccount', 'dataBank']),

		price_total() {
			let price_total = 0
			if (this.cart) {
				this.cart.forEach(el => {
					price_total += parseInt(el.product_price) * parseInt(el.quantity)
				});
			}
			return price_total;
		},
		remaining_amount() {
			let totalAmount = 0
			let materai = 0
			this.customerBankSplitPayment.forEach((item) => {
				if (item.customer_bank_transfer_amount)
					totalAmount += parseInt(item.customer_bank_transfer_amount)
			})
			if(this.price_total > 5000000){
				materai = 10000
			}
			return this.price_total - this.progressive_price_data.rebate_total + this.shipping_cost + materai - totalAmount;
		},
		materai(){
			let materai = 0
			if(this.price_total >= this.minimumPaymentMaterai){
				materai = 10000
			}
			return materai
		}
	},
	methods: {
		...mapMutations('po_cart', ['setPayment', 'setPaymentValue', 'setPaymentMethod', 'setPayTotal', 'paymentProgressAct', 'setBankCustomer', 'setBankCustomerSplitPayment']),
		...mapActions('po', ['getBankAccount', 'getBank']),

		remainCheck($event, index) {
			let otherTotal = 0;
			let materai = 0;

			this.customerBankSplitPayment.forEach((item, i) => {
				if (i !== index) {
					otherTotal += Number(item.customer_bank_transfer_amount || 0);
				}
			});

			if(this.price_total > 5000000){
				materai = 10000
			}

			const currentValue = Number(
				this.customerBankSplitPayment[index].customer_bank_transfer_amount || 0
			);

			const max = this.price_total - this.progressive_price_data.rebate_total + this.shipping_cost + materai - otherTotal;

			if (currentValue > max) {
				// Kembalikan ke nilai terakhir yang valid
				this.customerBankSplitPayment[index].customer_bank_transfer_amount =
					this.lastValidAmount[index] || 0;
			} else {
				// Simpan nilai valid
				this.lastValidAmount[index] = currentValue;
			}
		},
		addSplitPayment() {
			if (this.split_payment < 3) {
				this.split_payment += 1
			}
			this.customerBankSplitPayment.push({
				customer_bank_name: '',
				customer_bank_customer_name: '',
				customer_bank_customer_number: '',
				customer_bank_transfer_amount: ''
			})
			this.splitPayment.push({
				paymentValueObj: {},
				paymentValueName: '',
			})
		},
		removeSplitPayment(index) {
			if (this.split_payment > 2) {
				this.split_payment -= 1
			}
			this.customerBankSplitPayment.splice(index, 1)
			this.splitPayment.splice(index, 1)
			this.customerBankSplitSaved.splice(index, 1)
		},
		setPaymentMethodValue(item) {
			//console.log(this.paymentMethod)
			//console.log(this.paymentValue)
			//this.paymentProgressAct(true)

			if (this.paymentMethod.value == 1) {
				this.bankSelected = item
				this.validatePaymentBank()
			} else {
				this.bankSelected = {}
				this.paymentProgressAct(true)
			}
		},
		resetPaymentValue() {
			this.paymentValue = ''
			this.paymentProgressAct(false)
			this.customer_bank_name = ''
			this.customer_bank_customer_name = ''
			this.customer_bank_customer_number = ''
			this.paymentValueObj = {}
			this.paymentValueName = ''
			if (this.paymentMethod.value == 3) {
				this.split_payment = 2
				this.customerBankSplitPayment = [
					{
						customer_bank_name: '',
						customer_bank_customer_name: '',
						customer_bank_customer_number: '',
						customer_bank_transfer_amount: ''
					},
					{
						customer_bank_name: '',
						customer_bank_customer_name: '',
						customer_bank_customer_number: '',
						customer_bank_transfer_amount: ''
					}
				]
				this.customerBankSplitSaved = []
				this.splitPayment = [
					{
						paymentValueObj: {},
						paymentValueName: '',
					},
					{
						paymentValueObj: {},
						paymentValueName: '',
					}
				]
			}
		},
		validatePaymentBank() {
			//console.log('validatePaymentBank')
			//console.log(this.paymentValue)
			//console.log(this.customer_bank_name)

			var is_valid = true

			if (this.customer_bank_name == '') {
				is_valid = false
			}

			if (this.customer_bank_customer_name == '') {
				is_valid = false
			}

			if (this.customer_bank_customer_number == '') {
				is_valid = false
			}

			if (Object.keys(this.bankSelected).length == 0) {
				is_valid = false
			}

			if (is_valid) {
				this.setBankCustomer({
					customer_bank_name: this.customer_bank_name,
					customer_bank_customer_name: this.customer_bank_customer_name,
					customer_bank_customer_number: this.customer_bank_customer_number
				})

				this.paymentProgressAct(true)
			} else {
				this.paymentProgressAct(false)
			}
		},
		validateSplitPaymentBank(index) {

			var is_valid = true

			if (this.customerBankSplitPayment[index].customer_bank_name == '') {
				is_valid = false
			}

			if (this.customerBankSplitPayment[index].customer_bank_customer_name == '') {
				is_valid = false
			}

			if (this.customerBankSplitPayment[index].customer_bank_customer_number == '') {
				is_valid = false
			}

			if (Object.keys(this.splitPayment[index].paymentValueObj).length == 0) {
				is_valid = false
			}

			if (this.customerBankSplitPayment[index].customer_bank_transfer_amount == '' || this.customerBankSplitPayment[index].customer_bank_transfer_amount == 0) {
				is_valid = false
			}

			//check dupicate bank account number
			if (
				this.customerBankSplitPayment.some((item, index) =>
					this.customerBankSplitPayment.findIndex(
						x => x.customer_bank_customer_number === item.customer_bank_customer_number
					) !== index
				)
			) {
				is_valid = false
			}

			if (is_valid) {
				this.customerBankSplitSaved[index] = {
					customer_bank_name: this.customerBankSplitPayment[index].customer_bank_name,
					customer_bank_customer_name: this.customerBankSplitPayment[index].customer_bank_customer_name,
					customer_bank_customer_number: this.customerBankSplitPayment[index].customer_bank_customer_number,
					customer_bank_transfer_amount: this.customerBankSplitPayment[index].customer_bank_transfer_amount
				}

				if (this.customerBankSplitSaved.length == this.customerBankSplitPayment.length) {
					//check if all split payment is valid
					let totalAmount = 0
					this.customerBankSplitSaved.forEach((item) => {
						totalAmount += parseInt(item.customer_bank_transfer_amount)
					})
					
					let paymentPrice = this.price_total - this.progressive_price_data.rebate_total + this.shipping_cost + this.materai;
					if (totalAmount == paymentPrice) {
						this.setBankCustomerSplitPayment(this.customerBankSplitSaved)
						this.paymentProgressAct(true)
					} else {
						this.paymentProgressAct(false)
					}
				}
			} else {
				this.paymentProgressAct(false)
			}
		},
		setPaymentObj() {
			//console.log(this.paymentValueObj)
			this.paymentValue = this.paymentValueObj.bank_account_bank
			//console.log(this.paymentValue)
			this.setPaymentMethodValue(this.paymentValueObj)
			this.validatePaymentBank()
			this.paymentValueName = this.paymentValueObj.bank_account_name + ' - ' + this.paymentValueObj.bank_account_no
		},
		setSplitPaymentObj(index) {
			//console.log(this.splitPayment[index].paymentValueObj)
			this.splitPayment[index].paymentValueName = this.splitPayment[index].paymentValueObj.bank_account_name + ' - ' + this.splitPayment[index].paymentValueObj.bank_account_no
			this.splitPaymentValue[index] = this.splitPayment[index].paymentValueObj.bank_account_bank
			this.validateSplitPaymentBank(index)
		},
	},
	watch: {
		remaining_amount() {

		},
		paymentMethod() {
			this.setPayment(this.paymentMethod)
		},
		paymentValue() {
			this.setPaymentValue(this.paymentValue)

			var payment_method_value = this.paymentValue

			if (this.paymentMethod.value == 1) {
				payment_method_value = this.bankSelected.bank_account_id
			}

			this.setPaymentMethod({
				payment_method: this.paymentMethod.value,
				payment_method_value: payment_method_value
			})
		},
		splitPayment: {
			handler() {
				this.setPaymentValue(this.splitPaymentValue)

				var payment_method_value = this.splitPaymentValue

				if (this.paymentMethod.value == 3) {
					payment_method_value = []
					this.splitPayment.forEach((el) => {
						payment_method_value.push(el.paymentValueObj.bank_account_id)
					})
				}

				this.setPaymentMethod({
					payment_method: this.paymentMethod.value,
					payment_split_payment_method_value: payment_method_value
				})
			},
			deep: true
		}
	},
	created() {
		this.getBankAccount()
		this.getBank()
	},
	mounted() {
	}
};
</script>
